import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import { deletecategory, getcatorylist } from '../../actions/users';
import { toast } from 'react-toastify';
import moment from 'moment';

const CategoryList = () => {


    const navigate = useNavigate();


    const [categoryList, setCategoryList] = useState([]);

    useEffect(() => {
        getCatorylist();
    }, [])

    const getCatorylist = async () => {
        var test = await getcatorylist();
        setCategoryList(test.userValue);
    }

    const columns = [

        {

            key: "NFT Category",
            name: "NFT Category",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => (
                <p>{row?.name}</p>
            ),

        },
        // {

        //     key: "Date",
        //     name: "Date",
        //     // // className: "tokenId",
        //     align: "left",
        //     sortable: false,
        //     cell: (row, index, column, id) => (
        //         <p>{ moment(row.createdAt).format('MMMM,Do YYYY, hh:mm A')}</p>
        //     ),

        // },        
        {

            key: "Delete",
            name: "Delete",
            // className: "tokenQuantity",
            align: "left",
            sortable: false, cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteR(row.id)}
                            style={{ marginRight: '5px' }}
                        >
                            <RiDeleteBin5Line />
                        </button>
                    </Fragment>
                );
            }

        },
        {

            key: "Edit",
            name: "Edit",
            // className: "tokenBid",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-primary btn-sm"
                              onClick={() => navigate("/Viewcategory/"+row._id)}
                            style={{ marginRight: '5px' }}
                        >
                            <FaEye />
                        </button>
                    </Fragment>
                );
            }

        },
        {

            key: "Collection Promotion",
            name: "Collection Promotion",
            // className: "tokenBid",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => navigate("/collectionpromotion/"+row._id)}

                            style={{ marginRight: '5px' }}
                        >
                            <FaEye />
                        </button>
                    </Fragment>
                );
            }

        },
    ];

    function editR(id) {

        if (id != '') {
            navigate("/EditCategory/" + id);
        }

    }

    async function deleteR(id) {
        if (id != '') {

            const data = await deletecategory(id);
            if (data) {
                toast.success("Category deleted successfully", 1000);
                setTimeout(
                    () => navigate("/categorylist"),
                    1000);
                getCatorylist()
            }
        }
    }

    return (
        <Layout>
            <div className="categorylist">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h1 className="pagehead mb-0">Category List</h1>
                    <Link to="/AddCategory" className="btn sitebtn">Add Category</Link>
                </div>
                <div className="cardbox">
                    <div className="tablebox">
                        {/* <Form.Control type="text" placeholder="Filter in records" /> */}
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={categoryList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CategoryList;